import { View, Text, StyleSheet } from "react-native";
import React from "react";
import {
  Datepicker,
  DatepickerProps,
  NativeDateService,
} from "@ui-kitten/components";
import { UserFieldDetails } from "features/types";
import { FieldProps } from "formik";
import dayjs from "dayjs";

type Props = { userFieldType: UserFieldDetails["type"] } & FieldProps &
  DatepickerProps;

const today = new Date();
const oneYearFromToday = dayjs().add(1, "year").toDate();

const DatePickerInput = (props: Props) => {
  const {
    field: { name, onChange, value },
    form: { errors, touched },
    appearance = "default",
    label,
    // @ts-ignore
    innerRef,
    userFieldType = "STRING",
    status = "basic",
    ...restProps
  } = props;

  const hasError = touched[name] && errors[name];
  const formatDateService = new NativeDateService("en", {
    format: "MM/DD/YYYY",
  });

  const handleOnSelect = (value: Date) => {
    onChange(name)(new Date(value).toString());
  };

  const DayCell = (
    { date }: { date: Date },
    style: any
  ): React.ReactElement => (
    <View testID="day-cell" style={[styles.dayContainer, style.container]}>
      <Text style={style.text}>{date.getDate()}</Text>
    </View>
  );

  return (
    <Datepicker
      date={value ? new Date(value) : undefined}
      min={today}
      max={oneYearFromToday}
      placeholder="MM/DD/YYYY"
      // @ts-ignore
      onSelect={handleOnSelect}
      status={hasError ? "danger" : "basic"}
      dateService={formatDateService}
      label={(evaProps) => (
        <Text
          {...evaProps}
          style={[evaProps?.style, { color: "black", fontWeight: "500" }]}
        >
          {label as string}
        </Text>
      )}
      renderDay={DayCell}
      testID="date-picker-calendar"
      style={{ backgroundColor: "white" }}
      {...restProps}
    />
  );
};

export default DatePickerInput;
const styles = StyleSheet.create({
  dayContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    aspectRatio: 1,
  },
});
